import { combineReducers } from 'redux'
import MenuReducer from './MenuReducer'

export default combineReducers({
    MenuReducer
})